import { render, staticRenderFns } from "./DocLicensePlateRecognition.vue?vue&type=template&id=9fafd878&scoped=true"
import script from "./DocLicensePlateRecognition.vue?vue&type=script&lang=js"
export * from "./DocLicensePlateRecognition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fafd878",
  null
  
)

export default component.exports